import { get, post } from 'pc-sales/utils/http';

export class ClientApi {
    // 获取销售下级客户列表
    get = async (
        data: {
            page?: number;
            pagesize?: number;
            ustatus?: string;
            from?: string;
            to?: string;
            email?: string;
            phone?: string;
            uuid?: string;
            node?: string;
            isHierarchy?: string;
            audit_status?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/client/sales/relationChain', data, { signal: options?.signal });

    // 获取销售下级客户信息
    info = async (data: { id: string }) => await get('/v2/client/sales/info', data);

    // 改派自然客户的所属销售及客户组别（团队内）
    assignSales = async (data: { uuid: string; sales: string; groupId?: number }) =>
        await post('/v2/client/sales/assignSales', data);

    // 更新销售下级客户标签
    updateTags = async (data: { uuid: string; tags: object[] }) => await post('/v2/client/sales/updateTags', data);

    // 获取用户详情
    crmInfo = async (
        data: {
            uuid: string;
            salesType?: 'personal' | 'team';
        },
        options?: { ignoreError: boolean },
    ) => await get('/v2/client/crm/show', data, options);

    // 解密邮箱手机号
    decrypt = async (data: { uuid: string; type: 'email' | 'phone' }) => await get('/v2/client/crm/decrypt', data);

    // 获取销售下级客户交易账号列表
    account = async (
        data: {
            server_id: string;
            platform: 'MT4' | 'MT5';
            page: number | string;
            pagesize: number | string;
            from?: string;
            to?: string;
            login?: number | string;
            name?: string;
            esnl_acc_type_id?: number;
            sub_acc_type_id?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/client/mt', data, { signal: options?.signal });

    // 获取销售下级客户交易账号列表
    accounts = async (data: { uuid: string; is_live_server?: 1 | 0; extra?: string }) =>
        await get('/v2/user/profile/account', data);
}

export default new ClientApi();
